import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import CartItems from './CartItems';
import Totals from './Totals';
import receiptAnalytics from './receiptAnalytics';
import Button from '../Elements/Button/Button';
import ErrorBoundary from '../../hocs/ErrorBoundary/ErrorBoundary';
import { destroySelection } from '../../actions/checkout';
import { translate, deCamel } from '../../utils/string';
import { purifier, setCookie } from '../../utils/dom';
import s from './Receipt.scss';

class Receipt extends Component {
	constructor(props) {
		super(props);

		this.state = {
			conversionFired: false, // eslint-disable-line react/no-unused-state
			klarnaCheckoutRendered: false,
		};
	}

	static getDerivedStateFromProps(props, state) {
		/* Before render, initial mount and on update. */
		const { checkout, setup, properties, location } = props;

		if (typeof window !== 'undefined' && location.type !== 'RECEIPT_DEBUG' && !state.conversionFired && checkout.selection.items && checkout.selection.items.length > 0 && properties.siteUpdated) {
			if (typeof window.dataLayer === 'undefined') window.dataLayer = [];
			receiptAnalytics(checkout.selection, setup, checkout.listItemCache);

			setCookie('receiptShown', 1, 365);

			return { conversionFired: true };
		}

		return null;
	}

	componentDidUpdate() {
		const receiptSnippet = document.getElementById('receiptSnippet');
		if (this.props.checkout.selection.receiptSnippet && receiptSnippet && !this.state.klarnaCheckoutRendered) {
			// Insert checkout form.
			if (!receiptSnippet.querySelector('script')) return;
			const scriptContents = receiptSnippet.querySelector('script').innerHTML;
			const d = document.createElement('script');
			d.text = scriptContents;
			document.getElementById('receiptSnippet').appendChild(d);

			// Avoid re-rendering where available.
			// eslint-disable-next-line
			this.setState({
				klarnaCheckoutRendered: true,
			});
		}
	}

	componentWillUnmount() {
		if (this.props.location.type !== 'RECEIPT_DEBUG' && this.state.conversionFired) this.props.destroySelection();
	}

	render() {
		const { checkout, setup, location } = this.props;

		if (checkout.selectionError || !checkout.selection.items) {
			return null;
		}

		let { order, address, shippingAddress } = checkout.selection;
		const fieldOrder = ['email', 'firstName', 'lastName', 'company', 'phoneNumber', 'address1', 'address2', 'zipCode', 'city'];

		if (location.type === 'RECEIPT_DEBUG') {
			address = fieldOrder.reduce((acc, field) => ({ ...acc, [field]: deCamel(field) }), {});
			shippingAddress = fieldOrder.reduce((acc, field) => ({ ...acc, [field]: deCamel(field) }), {});
			order = 123456;
		}

		return (
			<main role="main">
				<div className={s.receipt}>
					<h1 className={s.receipt_title}>{ translate(setup, 'receiptTitle') }</h1>
					<div className={s.receipt_thanks} dangerouslySetInnerHTML={{ __html: purifier(translate(setup, 'receiptThanks')) }} />
					<h3 className={s.receipt_orderNumber}>{ translate(setup, 'receiptOrderNumber') }{ order }</h3>
					<ErrorBoundary message="Error rendering receipt" debugData={checkout.selection}>
						{ checkout.selection.receiptSnippet && <div id="receiptSnippet" className={s.receipt_snippet} dangerouslySetInnerHTML={{ __html: checkout.selection.receiptSnippet }} /> }
						<CartItems currentPage="receipt" />
						<div className={s.receipt_totals}>
							<Totals setup={setup} selection={checkout.selection} />
						</div>
						<div className={s.receipt_address}>
							<div className={s.receipt_address_column}>
								<span className={s.receipt_address_column_title}>{ translate(setup, 'receiptAddressBilling') }</span>
								{
									fieldOrder.map((field) => {
										if (!address[field]) return null;
										return (
											<span key={`address-${field}`} className={s.receipt_address_column_row}>
												{ address[field] }
											</span>
										);
									})
								}
							</div>
							<div className={s.receipt_address_column}>
								<span className={s.receipt_address_column_title}>{ translate(setup, 'receiptAddressShipping') }</span>
								{
									fieldOrder.map((field) => {
										if (!shippingAddress[field]) return null;
										return (
											<span key={`address-${field}`} className={s.receipt_address_column_row}>
												{ shippingAddress[field] }
											</span>
										);
									})
								}
							</div>
						</div>
					</ErrorBoundary>
					<div className={s.receipt_print}>
						<Button text={translate(setup, 'receiptPrint')} type="a" href="#print-receipt" clickEventHandler={(e) => { e.preventDefault(); window.print(); }} />
					</div>
				</div>
			</main>
		);
	}
}

const mapState = ({ checkout, environment, location }) => (
	{ checkout, setup: environment.setup, properties: environment.properties, location }
);

export default hot(module)(connect(mapState, { destroySelection })(Receipt));
